export enum UserFlairType {
  founding_member = 'founding_member',
  mentor = 'mentor',
  none = '',
  super_user = 'super_user',
  team_daisie = 'team_daisie',
  verified = 'verified',
}
